import { render, staticRenderFns } from "./TriggerField.vue?vue&type=template&id=58b04d87&lang=pug&"
import script from "./TriggerField.vue?vue&type=script&lang=js&"
export * from "./TriggerField.vue?vue&type=script&lang=js&"
import style0 from "./TriggerField.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58b04d87')) {
      api.createRecord('58b04d87', component.options)
    } else {
      api.reload('58b04d87', component.options)
    }
    module.hot.accept("./TriggerField.vue?vue&type=template&id=58b04d87&lang=pug&", function () {
      api.rerender('58b04d87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/specific/TriggerField.vue"
export default component.exports